import { UsersTable } from "../../components/tables/UsersTable"




interface IUsersManagementProps {

}


/**
 * Users management table
 * @returns 
 */

export const UserManagement = (props: IUsersManagementProps) => {
  return (<UsersTable />)
}